import React from 'react';
import { FaClock, FaCalendarAlt } from 'react-icons/fa';
import './OpeningHours.css';

const OpeningHours = () => {
  const hours = [
    { day: "Monday", time: "09:00 AM - 09:00 PM" },
    { day: "Tuesday", time: "09:00 AM - 09:00 PM" },
    { day: "Wednesday", time: "09:00 AM - 09:00 PM" },
    { day: "Thursday", time: "09:00 AM - 09:00 PM" },
    { day: "Friday", time: "09:00 AM - 09:00 PM" },
    { day: "Saturday", time: "09:00 AM - 09:00 PM" },
    { day: "Sunday", time: "Closed" },
  ];

  return (
    <section className="opening-hours-section">
      <div className="container">
        <div className="glass-card" data-aos="zoom-in">
          <div className="card-header">
            <FaClock className="header-icon" />
            <h3>Opening <span>Hours</span></h3>
          </div>
          <div className="hours-list">
            {hours.map((item, index) => (
              <div key={index} className="hours-item">
                <span className="day">{item.day}</span>
                <span className="time">{item.time}</span>
              </div>
            ))}
          </div>
          <div className="card-footer">
            <p><FaCalendarAlt /> Open 6 days a week for your convenience.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;
